import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    didReceiveMemoryWarning: false,
    activedKey: '',
    userActionHistory: [],
    resigerInfos: [],
};
const AutoUnmountSlice = createSlice({
    name: 'AutoUnmountReducer',
    initialState,
    reducers: {
        register: (state, action) => {
            let exists = state.resigerInfos;
            const payload = action.payload;
            let existIndex = -1;
            exists.forEach((i, index) => {
                if (i.module === payload.module && i.page === payload.page) {
                    existIndex = index;
                }
            });
            if (existIndex > -1) {
                state.resigerInfos.splice(existIndex, 1);
            }
            state.resigerInfos.push(action.payload);
        },
        setUserAction: (state, action) => {
            let exists = state.userActionHistory;
            const payload = action.payload;
            let registeredInfo = state.resigerInfos;
            let have = false;
            registeredInfo.forEach(i => {
                if (i.module === payload.module && i.page === payload.page) {
                    have = true;
                }
            });
            if (!have) {
                return;
            }
            let existIndex = -1;
            exists.forEach((i, index) => {
                if (i.module === payload.module && i.page === payload.page) {
                    existIndex = index;
                }
            });
            if (existIndex > -1) {
                state.userActionHistory.splice(existIndex, 1);
            }
            state.userActionHistory.push(action.payload);
            if (state.userActionHistory.length > 2) {
            }
        },
    },
});
export const { actions } = AutoUnmountSlice;
export default AutoUnmountSlice.reducer;
